import { HYDRATE } from 'next-redux-wrapper';

import { QUIZ_CHANGE_ANSWERS,
    QUIZ_CLEAR_QUESTIONS,
    QUIZ_ERROR,
    QUIZ_NEXT_STEP,
    QUIZ_PREV_STEP,
    QUIZ_REQUEST_DATA,
    QUIZ_SEND_ERROR,
    QUIZ_SET_IS_SENDED,
    QUIZ_SET_IS_SHOW,
    QUIZ_SET_ROUTER,
    QUIZ_SET_TARIFF,
    QUIZ_SET_TARIFFS,
    QUIZ_SET_TV_BOX,
    QUIZ_SHOW_TARIFF } from '../actionTypes/quiz';

const initialState = {
    questions: [],
    stepQuiz: 0,
    loading: false,
    showTariff: false,
    error: false,
    pickedUpTariff: null,
    pickedUpRouter: null,
    pickedUpTvBox: null,
    quiz: {},
    isSended: false,
    isShowQuiz: true,
    isSendError: false,
    tariffs: [],
};

export default (state = initialState, action) => {

    const { type, payload } = action;
    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.quiz };
        case QUIZ_NEXT_STEP:
            return ({
                ...state,
                stepQuiz: payload,
            });
        case QUIZ_PREV_STEP:
            return ({
                ...state,
                stepQuiz: state.stepQuiz - 1,
            });
        case QUIZ_REQUEST_DATA:
            return ({
                ...initialState,
                questions: [...payload.questions],
                quiz: { ...payload.quiz },
            });
        case QUIZ_CHANGE_ANSWERS:
            return ({
                ...state,
                questions: [...payload.questions],
                stepQuizCheck: payload.stepQuizCheck,
            });
        case QUIZ_SHOW_TARIFF:
            return ({
                ...state,
                showTariff: payload,
            });
        case QUIZ_ERROR:
            return ({
                ...state,
                error: payload,
            });
        case QUIZ_SET_TARIFF:
            return ({
                ...state,
                pickedUpTariff: { ...payload },
            });
        case QUIZ_SET_ROUTER:
            return ({
                ...state,
                pickedUpRouter: { ...payload },
            });
        case QUIZ_SET_TV_BOX:
            return ({
                ...state,
                pickedUpTvBox: { ...payload },
            });
        case QUIZ_CLEAR_QUESTIONS:
            return ({
                ...state,
                questions: [...payload],
            });
        case QUIZ_SET_IS_SENDED:
            return ({
                ...state,
                isSended: payload,
                name: action.name,
            });
        case QUIZ_SET_IS_SHOW:
            return ({
                ...state,
                isShowQuiz: payload,
            });
        case QUIZ_SEND_ERROR:
            return ({
                ...state,
                isSendError: payload,
            });
        case QUIZ_SET_TARIFFS:
            return ({
                ...state,
                tariffs: [...payload],
            });
        default:
            return state;
    }
};
